import { useAuthContext } from 'context/authContext';

export default function useBranchPermission() {
  const { selectedBranchId, isAllBranches, is_main } = useAuthContext();

  // Return null for "all branches", otherwise return the specific branch ID
  const branchId =
    selectedBranchId === 'all' || isAllBranches ? null : selectedBranchId;

  return {
    branchId,
    // Main branch acts as HQ: beneficiary READ queries drop the branch filter
    // for its staff (RLS grants them org-wide orphan access)
    isMainBranch: Boolean(is_main)
  };
}
